// Fill these in yourself. Anything in [brackets] is shown on the site as a visible placeholder. Never invent values.
export const BUSINESS = {
  brandName: "Mirai Educations",
  legalName: "[ADD: legal entity name]",
  cin: "[ADD: CIN or registration number]",
  gstin: "[ADD: GSTIN, if registered]",
  address: "Mirai Educations, Ashiyana, Lucknow, Uttar Pradesh 226012",
  phone: "7311101115",
  email: "support@miraieducations.com",
  jurisdictionCity: "Lucknow",
  lastLegalReviewDate: "[ADD: date of lawyer review]",
  retentionDays: 180,
};
